import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { ControlValidationService } from '../control-validation.service';

@Component({
  selector: 'portal-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() icon: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() hintStart: string | SafeHtml;
  @Input() hintEnd: string | SafeHtml;
  @Input() prefix: string | SafeHtml;
  @Input() suffix: string | SafeHtml;
  @Input() customErrors: { [key: string]: any };
  @Input() minDate: Date;
  @Input() maxDate: Date;
  control: AbstractControl;
  isRequired: boolean;
  errorList: { [key: string]: any };

  constructor(private controlValidationService: ControlValidationService) {}

  ngOnInit() {
    if (this.controlName) {
      this.control = this.form.get(this.controlName);
      if (this.control.errors) {
        this.isRequired = this.control.errors.required && true;
      }
    }
  }

  errors(control: AbstractControl): string {
    const { errors } = control;
    if (errors) {
      const inputName = this.label || this.controlName;
      this.errorList = this.controlValidationService.commonErrors(
        this.control,
        inputName
      );
      if (this.customErrors) {
        this.errorList = { ...this.errorList, ...this.customErrors };
      }
      const i = Object.keys(errors).length - 1;
      return this.errorList[Object.keys(errors)[i]];
    }
  }
}
